<template>
  <router-view />
</template>

<script setup lang="ts">
import { useSsoEvents } from '@/composables/useSsoEvents'

useSsoEvents()
</script>
